import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { useNavigate } from 'react-router-dom';

const ProgramServiceAddForm = () => {
  const [form, setForm] = useState({
    type: '',
    program_id: '',
    file: null,
  });

  const [errors, setErrors] = useState({});
  const [typeOptions] = useState([
    { value: 'student', label: 'Student' },
    { value: 'kids', label: 'Kids' },
  ]);
    const [dataList, setDataList] = useState([]);

  const [programOptions, setProgramOptions] = useState([]);

  const [responce, loading, error, callAPI,statusCode] = useApiCallHooks();
  const [studentresponce, , studentError, callStudentAPI] = useApiCallHooks();
const navigate=useNavigate();
  useEffect(() => {
    fetchList();
    fetchPrograms();
  }, []);
  
  const fetchList = () => {
    callAPI('get', 'admin/program-service')
      setDataList(responce?.data || [])
   ;
  };
  const fetchPrograms = () => {
    callAPI('get', 'admin/programs', null, (res) => {
      setProgramOptions(responce?.data || []);
    });
  };


  // Handle form field changes
  const handleTypeChange = (selectedOption) => {
    const selectedType = selectedOption?.value || '';
    setForm({ ...form, type: selectedType, program_id: '' });
    setErrors((prev) => ({ ...prev, type: '', program_id: '' }));

    if (selectedType) {
      callStudentAPI('get', `get-program-student-list/${selectedType}`);
    } else {
      setProgramOptions([]);
    }
  };

  const handleProgramChange = (selectedOption) => {
    setForm((prev) => ({
      ...prev,
      program_id: selectedOption?.value || '',
    }));
    setErrors((prev) => ({ ...prev, program_id: '' }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({
      ...prev,
      file: e.target.files[0],
    }));
    setErrors((prev) => ({ ...prev, file: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.type) newErrors.type = 'Type is required';
    if (!form.program_id) newErrors.program_id = 'Program is required';
    if (!form.file) newErrors.file = 'File is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = new FormData();
    payload.append('type', form.type);
    payload.append('program_id', form.program_id);
    payload.append('file', form.file);

    callAPI('post', 'admin/program-resource ', payload, (res) => {
      toast.success(res?.message || 'File uploaded successfully!');
      setForm({ type: '', program_id: '', file: null });
      setProgramOptions([]);
    }, true);
  };

  useEffect(() => {
    if (studentresponce?.data?.programs) {
      const mappedPrograms = studentresponce.data.programs.map((p) => ({
        value: p.id,
        label: p.name,
      }));
      setProgramOptions(mappedPrograms);
    }
  }, [studentresponce]);

  // useEffect(() => {
  //   if (error) {
  //     toast.error(error?.message || 'Something went wrong');
  //   }
  //   if (studentError) {
  //     toast.error(studentError?.message || 'Failed to fetch programs');
  //   }
  // }, [error, studentError]);

  useEffect(()=>{
    if(statusCode===201){
navigate("/program-service/list")
    }
  },[statusCode]);

  return (
    <AdminAppBody
    content={
    <div className="container mt-4">
      <h4>Add Program Service</h4>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        {/* Type */}
        <div className="mb-3">
          <label className="form-label">Type</label>
          <Select
            options={typeOptions}
            value={typeOptions.find((opt) => opt.value === form.type) || null}
            onChange={handleTypeChange}
            placeholder="Select type"
            isClearable
          />
          {errors.type && <span className="text-danger">{errors.type}</span>}
        </div>

        {/* Program */}
        <div className="mb-3">
          <label className="form-label">Program</label>
          <Select
            options={programOptions}
            value={programOptions.find((opt) => opt.value === form.program_id) || null}
            onChange={handleProgramChange}
            placeholder="Select program"
            isDisabled={!form.type}
            isClearable
          />
          {errors.program_id && <span className="text-danger">{errors.program_id}</span>}
        </div>

        {/* File */}
        <div className="mb-3">
          <label className="form-label">Upload File</label>
          <input
            type="file"
            name="file"
            onChange={handleFileChange}
            className="form-control"
          />
          {errors.file && <span className="text-danger">{errors.file}</span>}
        </div>

        {/* Submit */}
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
    }
    />
  );
};

export default ProgramServiceAddForm;
